import { Table as MuiTable, TableContainer } from "@mui/material";
import TableHeader from "./components/TableHeader";
import TableBody from "./components/TableBody";
import TableFooter from "./components/TableFooter";
import InvokerAddressSelectionRow from "./components/InvokerAddressSelectionRow";

const tableContainerSx = {
  overflowX: "auto",
};

function Table() {
  return (
    <>
      <TableContainer sx={tableContainerSx}>
        <MuiTable>
          <TableHeader />
          <TableBody />
          <TableFooter />
        </MuiTable>
      </TableContainer>
      <InvokerAddressSelectionRow />
    </>
  );
}

export default Table;
